import { Button, Tooltip } from '@roo/roo';
import React from 'react';
import CryptoJs from 'crypto-js';
import { getCopyUrl, OwnFlagEnum, ICopyButtonProps } from '../api';
import util from '../../../utils/utils';

const { useState, useRef } = React;

const Index = (props: ICopyButtonProps) => {
    const { id, ownFlag, name } = props;
    const [disable, setDisable] = useState(false);
    const textInputRef = useRef<HTMLInputElement>(null);

    const copyText = (text: string) => {
        if (textInputRef.current) {
            try {
                console.log('textInputRef.current', textInputRef.current);
                textInputRef.current.value = text;
                textInputRef.current.select();
                const flag = document.execCommand('Copy');
                textInputRef.current.blur();
                console.log('flag', flag);
                if (flag) {
                    util.toast('success', '复制成功');
                } else {
                    alert(`当前浏览器不支持复制功能，请手动复制信息：\n${text}`);
                }
            } catch (err) {
                alert(`当前浏览器不支持复制功能，请手动复制信息：\n${text}`);
            }
        }
    };

    const handleClick = () => {
        setDisable(true);
        const preText =
            ownFlag === OwnFlagEnum.other
                ? '欢迎了解美团官方代运营，您可放心点击商品前往购买：'
                : '您可以点击商品前往购买，';
        // 官代商品的复制
        if (ownFlag === OwnFlagEnum.other) {
            getCopyUrl({ itemId: id })
                .then(res => {
                    const url = res.data;
                    console.log('url', url);
                    const text = `${preText}${url}`;
                    copyText(text);
                })
                .finally(() => {
                    setDisable(false);
                });
        } else {
            // 其他类目的商品复制
            const aseValue = `${CryptoJs.AES.encrypt(`${id}^*&#${name}`, 'maoda').toString()}end`;
            const text = `${preText}${aseValue}`;
            copyText(text);
            setDisable(false);
        }
    };

    return (
        <>
            <Button onClick={handleClick} type="text" disabled={disable}>
                复制链接
            </Button>
            <Tooltip
                content="可点击复制服务的购买链接，通过大象客服发给用户，方便购买"
                effect="light"
            >
                <span className="ques-tip">?</span>
            </Tooltip>
            <input ref={textInputRef} className="out-of-screen" />
        </>
    );
};

export default Index;
